import React, { useRef, useState } from "react";
import { useSelector } from 'react-redux';
import { Button, Col, Container, Content, Drawer, Modal, Progress, Row } from 'rsuite';
import Catalog from 'components/Catalog.js';
import axios from "axios";
import { jsPDF } from "jspdf";
import $ from 'jquery';
require('utils/svgToPDF');

function PDFCreator({ showPreview, setShowPreview, selectedArticulos, proyectKey, proyectHeaderText, proyectName, proyectPriceList, setProyectPDF, proyectGroupType, proyectUser, validityTo }) {
    const site = useSelector(state => state.site);
    const apiURL = site.site.apiServer;
    const [progressTitle, setProgressTitle] = useState("");
    const [progressValue, setProgressValue] = useState(0);
    const [progressTotal, setProgressTotal] = useState(0);
    const [progressPercent, setProgressPercent] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [progressStatus, setProgressStatus] = useState(null);
    const [progressMessage, setProgressMessage] = useState("");
    const [articulos, setArticulos] = useState([]);
    const background = useRef(null);
    const backgroundSVG = useRef('');
    const cancelPDF = useRef(false);
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    const loadBackground = async () => {
        await fetch(`${site.site.apiServer}/catalogo/res/background`)
            .then(async (response) => {
                let blob = await response.blob();
                let buffer = await blob.arrayBuffer();
                let dv = new DataView(buffer, 0, 5);
                let nume1 = dv.getUint8(0, true);
                let nume2 = dv.getUint8(1, true);
                let hex = nume1.toString(16) + nume2.toString(16);
                let type = "";
                backgroundSVG.current = '';
                switch (hex) {
                    case "8950":
                        type = "image/png";
                        break;
                    case "4749":
                        type = "image/gif";
                        break;
                    case "ffd8":
                        type = "image/jpeg";
                        break;
                    case "3c3f":
                        type = "image/svg+xml";
                        backgroundSVG.current = String.fromCharCode.apply(null, new Uint8Array(buffer));
                        break;
                    default:
                        type = null;
                        break;
                }
                console.log(type);
            });
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = (e) => {
                console.log(e);
                if ('mimeType' in img) {
                    console.log(img.mimeType);
                } else {
                    console.log(img);
                }
                resolve(img)
            };
            img.onerror = reject;
            img.src = `${site.site.apiServer}/catalogo/res/background`;
        })
    }

    const PDFCreateWrapper = async () => {
        if (background.current == null)
            background.current = await loadBackground();
        let totalPages = 0;
        for (let i = 0; $("#page_" + i).length !== 0; i++)
            totalPages++;

        /* INICIALIZO PROGRESS */
        setProgressTotal(totalPages);
        setProgressValue(0);
        setProgressStatus(null);
        setShowProgress(true);
        setProgressTitle("Renderizando página");

        let jsPDFDoc = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4', compress: true })
            .setProperties({ title: proyectName, subject: '', author: 'wiseSoft - Catálogo en línea', creator: 'wiseSoft - Catálogo en línea' })
            .setCreationDate(new Date());
        let file = null;

        for (let i = 0; i < totalPages; i++) {
            let el = $("#page_" + i).clone().css({ 'background-image': 'none' }); //.html();
            setProgressValue(i + 1);
            setProgressPercent(((i + 1) * 100 / totalPages).toFixed(2));
            file = await new Promise((resolve, reject) => PDFRenderPage(jsPDFDoc, el, i, i === totalPages - 1, (successResponse) => resolve(successResponse), (errorResponse) => reject(errorResponse)));
            if (cancelPDF.current) {
                setShowProgress(false);
                setShowPreview(false);
                cancelPDF.current = false;
                return;
            }
            jsPDFDoc = jsPDFDoc.addPage();
        }

        let fileURL = URL.createObjectURL(file);
        if (proyectKey && proyectKey.length > 0) {

            setProgressTitle("Subiendo PDF (bytes)");
            setProgressStatus(null);
            setProgressTotal(file.size);
            setProgressValue(0);
            setProgressPercent(0);

            let fd = new FormData();
            fd.append('blobData', file, proyectKey);
            fd.append('proyectKey', proyectKey);
            await axios
                .postForm(`${apiURL}/catalogo/uploadpdf`, fd, {
                    token: JSON.parse(atob(localStorage.getItem("token"))).at,
                    'Content-Type': 'multipart/form-data',
                    onUploadProgress: (progressEvent) => {
                        const { loaded, total } = progressEvent;
                        let percent = Math.floor((loaded * 100) / total);
                        if (percent < 100) {
                            setProgressTotal(total);
                            setProgressValue(loaded);
                            setProgressPercent(percent.toFixed(2));
                            console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
                        }
                    }
                })
                .then((response) => {
                    console.log(response);
                    if (response.data.result) {
                        setProgressStatus('success');
                        setProgressPercent(100);
                        setProyectPDF(true);
                        let a = document.createElement("a")
                        document.body.appendChild(a);
                        a.style = "display:none";
                        a.href = fileURL;
                        a.download = 'catalogo_' + proyectName;
                        a.click();
                        window.URL.revokeObjectURL(fileURL);
                        setTimeout(() => {
                            setShowPreview(false);
                            setProgressStatus(null);
                            setProgressPercent(0);
                            setTimeout(() => setShowProgress(false), 1000);
                        }, 500);
                    }
                })
                .catch((error) => {
                    setProgressStatus('fail');
                    setProgressMessage("Ocurrió un error al subir el archivo.");
                    setTimeout(() => {
                        setShowPreview(false);
                        setProgressStatus(null);
                        setProgressPercent(0);
                        setProgressMessage("");
                        setTimeout(() => setShowProgress(false), 1000);
                    }, 1500);
                });
        } else {
            setTimeout(() => setShowProgress(false), 1000);
            setTimeout(() => { window.open(fileURL); window.URL.revokeObjectURL(fileURL);}, 1500);
        }
        
    };

    const PDFRenderPage = async (doc, el, page, final, success, error) => {
        console.log(`rendering ${page}`);
        if (backgroundSVG.current !== '')
            doc.addSVG(backgroundSVG.current.replace(/\r?\n|\r/g, '').trim(), 0, 0, { scale: 1, removeInvalid: true });
        else
            doc.addImage(background.current, 'JPEG', 0, 0, 595.28, 841.89, null, 'FAST');
        console.log('loading images');
        const imgs = $('img[data-src]', el), objs = [], request = [], views = [];
        for (let i = 0; i < imgs.length; i++) {
            let v = $(imgs[i]);
            views.push(v);
            request.push(fetch(v.attr('data-src')));
        }
        await Promise.all(request).then((responses) => Promise.all(responses.map((response, index) => response.blob().then((blob) => { objs.push(URL.createObjectURL(blob)); $(views[index]).attr('src', objs[objs.length - 1]); }))));
        console.log('images loaded');
        doc.html(el[0], {
            image: { type: 'jpeg', quality: .8 },
            html2canvas: {
                useCORS: true, letterRendering: true, allowTaint: true, backgroundColor: null, height: 1122,
                onclone: (doc) => {
                    for (let i = 0; $("#page_" + i, $(doc)).length !== 0; i++)
                        if (i != page)
                            $("#page_" + i, $(doc)).remove();
                }
            },
            callback: function (pdf) {
                let blob = final ? pdf.output('blob') : null;;
                for (let i = 0; i < objs.length; i++)
                    URL.revokeObjectURL(objs[i]);
                success(blob);
            },
            margin: [0, 0, 0, 0],
            autoPaging: false,
            windowWidth: 793.706,
            width: 595.28,
            height: 841.89
        });
    }

    React.useEffect(() => {
        let art = JSON.parse(JSON.stringify(selectedArticulos));
        art.map((i) => {
            i.subrubroID = i.svalue;
            i.rubroID = i.rvalue;
            switch (proyectPriceList) {
                case -1:
                    i.price = 0;
                    break;
                case 0:
                    i.price = 0;
                    break;
                case 1:
                    i.price = i.pventa1;
                    break;
                case 2:
                    i.price = i.pventa2;
                    break;
                case 3:
                    i.price = i.pventa3;
                    break;
                case 4:
                    i.price = i.pventaSuc;
                    break;
                default:
                    i.price = i.pventaSuc;
                    break;
            }
        });
        setArticulos(art);
    }, [selectedArticulos, proyectPriceList]);

    React.useEffect(() => {
        console.log('PDF Creator loaded');

        var head = document.head;
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = `${site.site.apiServer}/catalogo/res/vc`;

        var link1 = document.createElement("link");
        link1.type = "text/css";
        link1.rel = "stylesheet";
        link1.href = "./defaultPage.css";

        var fonts_css = document.createElement("link");
        fonts_css.type = "text/css";
        fonts_css.rel = "stylesheet";
        fonts_css.href = `${site.site.apiServer}/catalogo/res/fonts`;


        var fonts_js = document.createElement("script");
        fonts_js.type = "module";
        fonts_js.src = `${site.site.apiServer}/catalogo/res/pdf-fonts`;


        head.appendChild(link1);
        head.appendChild(link);
        head.appendChild(fonts_css);
        head.appendChild(fonts_js);

        return () => { head.removeChild(link); head.removeChild(link1); head.removeChild(fonts_css); head.removeChild(fonts_js); console.log('PDF Creator unloaded'); }
    }, []);

    return (
        <>
            <Drawer backdrop="static" size="xs" placement="top" open={showProgress} onClose={() => { setShowProgress(false); cancelPDF.current = true; }}>
                <Drawer.Header>
                    <Drawer.Title>Generando PDF</Drawer.Title>
                    <Drawer.Actions>
                        <Button onClick={() => { setShowProgress(false); cancelPDF.current = true; }}>Cancelar</Button>
                    </Drawer.Actions>
                </Drawer.Header>
                <Drawer.Body>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            {progressTitle} {progressValue} de {progressTotal}
                        </Col>
                        <Col md={12}>
                            <Progress.Line percent={progressPercent}
                                strokeColor={progressPercent === 100 ? '#52c41a' : '#3385ff'} status={progressStatus} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} mdOffset={6}>
                            <h6>{progressMessage}</h6>
                        </Col>
                    </Row>
                </Drawer.Body>
            </Drawer>

            {showPreview && (
                <Modal open={showPreview} size="full" overflow={false} onClose={() => { setShowPreview(false) }} id={proyectKey && proyectKey.length > 0 ? "pdf-wrapper" : "pdf-wrapper-preview"}>
                    <Modal.Header>
                        <Modal.Title>Previsualización. <Button disabled={true} style={{display: 'none'}} appearance="link" size="md" active onClick={() => PDFCreateWrapper()} >
                            Haga click aqui para generar un PDF
                        </Button></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Content>
                                <Catalog articulos={articulos} groupType={proyectGroupType} headerText={proyectHeaderText} proyectUser={proyectUser} validityTo={validityTo}
                                    httpOnly={!(proyectKey && proyectKey.length > 0)} />
                                {proyectKey && proyectKey.length > 0 && (<img src="./logo.png" alt="logo" style={{ height: 0, maxHeight: 0 }} onLoad={() => {
                                    console.log('loaded');
                                    setTimeout(() => PDFCreateWrapper(), 1000);
                                }} />)}
                            </Content>
                        </Container>
                    </Modal.Body>
                </Modal>)
            }



        </>
    );
}

export default PDFCreator;